export default __webpack_public_path__ + "static/waart-ace0d910b88cbb127214971dddd3b757.jpg";